"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Chart() {
    return (react_1.default.createElement("svg", { width: "56", height: "56", viewBox: "0 0 56 56" },
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("rect", { width: "56", height: "56" }),
            react_1.default.createElement("rect", { width: "12", height: "24.347", x: "4", y: "28.653", fill: "#F5F5F5", stroke: "#BFBFBF", strokeWidth: "2" }),
            react_1.default.createElement("rect", { width: "12", height: "50", x: "22", y: "3", fill: "#F5F5F5", stroke: "#BFBFBF", strokeWidth: "2" }),
            react_1.default.createElement("rect", { width: "12", height: "37.52", x: "40", y: "15.48", fill: "#F5F5F5", stroke: "#BFBFBF", strokeWidth: "2" }))));
}
exports.default = Chart;
//# sourceMappingURL=Chart.js.map